<template>
    <div>
        <PolicyItem
            v-for=" (i) in policyList"
            :key="i"
            :policyDetail="i"
        ></PolicyItem>
    </div>
</template>

<script>
import PolicyItem from './PolicyItem.vue'
import Policyservice from '../service/PolicyService.js'
export default {
    name: 'PolicyList',
    components: {
        PolicyItem
    },
    data: function() {
        return {
            policyList : [],
        }
    },
    created: function() {
        this.getList()
    },
    methods: {
        getList: function() {
            return new Promise((resolve) => {
                Policyservice.apiGetPolicy().subscribe({
                    next: (policy) => {
                        this.policyList = policy
                        // console.log(this.policyList)
                        resolve();
                        this.$emit('onLoaded');
                    },
                    error: (err) => {
                        this.errorApi(err);

                        resolve();
                    },
                });
            });
        }
    }
}
</script>


